module.exports = __webpack_public_path__ + "img/1566833856.2c290181.jpg";